module.exports = __webpack_public_path__ + "assets/5f5d8c3747e4bbed262638f3f4fa3740.png";